import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import RedirectToStore from './RedirectToStore';
import AboutMe from './AboutMe';
import PrivacyPolicy from './PrivacyPolicy';
import './App.css';

import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<RedirectToStore />} />
        <Route path="/about" element={<AboutMe />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        {/* Redirect any unknown paths to Home */}
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
